import React from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix para ícones do Leaflet no React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Marcador vermelho estilo "pin" (como no Google Earth)
const redIcon = new L.Icon({
    iconUrl: 'https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

function MapUpdater({ center }) {
    const map = useMap();
    React.useEffect(() => {
        if (center) map.setView(center, 18);
    }, [map, center]);
    return null;
}

/**
 * Mapa em estilo satélite/Earth (ESRI World Imagery - gratuito)
 */
const SatelliteMap = ({ lat, lng, height = 420 }) => {
    const latNum = lat != null ? Number(lat) : null;
    const lngNum = lng != null ? Number(lng) : null;

    if (latNum == null || lngNum == null || isNaN(latNum) || isNaN(lngNum)) {
        return null;
    }

    const position = [latNum, lngNum];

    return (
        <div style={{ height, width: '100%', borderRadius: 8, overflow: 'hidden' }}>
            <MapContainer
                center={position}
                zoom={18}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={true}
                zoomControl={true}
            >
                <MapUpdater center={position} />
                <TileLayer
                    attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                />
                <Marker position={position} icon={redIcon} />
            </MapContainer>
        </div>
    );
};

export default SatelliteMap;
